module.exports = __webpack_public_path__ + "media/square-1.7d2cd904.mp4";